import React from 'react';
import PropTypes from 'prop-types';
import Terms from '../Sections/Terms/Terms';
import { commitMutation, graphql } from 'react-relay';
import { Analytics, GlobalNotifications, Intent } from '../../Modules';

export default class ContractTerms extends React.Component {

  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    node: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      terms: this.props.node.terms
    };
    this.termsChangeHandler = this.termsChangeHandler.bind(this);
    this.updateTerms = this.updateTerms.bind(this);
    this.resetTerms = this.resetTerms.bind(this);
    this.createSignatureBlock = this.createSignatureBlock.bind(this);
    this.insertGeneratedTerms = this.insertGeneratedTerms.bind(this);
    this.builderSaveTerms = this.builderSaveTerms.bind(this);
  }

  signatureBlockFactory() {
    return ({
      address_visibility: 'HIDE',
      company_name_visibility: 'HIDE',
      email_visibility: 'SHOW',
      name_visibility: 'SHOW',
      phone_visibility: 'SHOW',
      signer_fills_fields: true,
      title_visibility: 'HIDE'
    });
  }

  termsChangeHandler(value) {
    this.setState({ terms: value });
  }

  builderSaveTerms(terms, successCb) {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to generate contract',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully generated contract terms',
        intent: Intent.SUCCESS
      });
      this.setState({ terms: this.props.node.terms });
      if (successCb) successCb();
      Analytics.trackEvent('used-contract-generator');
    };

    this.createSignatureBlock(
      Object.assign(this.signatureBlockFactory(), { signing_party: 'Client' }),
      () => this.createSignatureBlock(
        Object.assign(this.signatureBlockFactory(), { signing_party: 'DJ' }),
        () => this.insertGeneratedTerms(terms, onCompleted, onError),
        onError
      ),
      onError
    );
  }

  insertGeneratedTerms(terms, successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
    };
    const onCompleted = () => {
      if (successCb) successCb();
    };
    const { id } = this.props.node;

    const mutation = graphql`
      mutation Terms_Contract_Generated_UpdateContractMutation(
        $input: UpdateContractInput!
      ) {
        updateContract(input: $input) {
          contract {
            terms
          }
        }
      }
    `;

    const optimisticResponse = {
      updateContract: { contract: { id, terms } }
    };
    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id,
          terms
        }
      },
      optimisticResponse,
      onCompleted,
      onError
    });
  }

  updateTerms(successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to update contract terms',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully updated contract terms',
        intent: Intent.SUCCESS
      });
    };

    // Set default terms if null
    const terms = this.state.terms === '<p><br></p>' ? null : this.state.terms;
    const { id } = this.props.node;

    const mutation = graphql`
      mutation Terms_Contract_UpdateContractMutation(
        $input: UpdateContractInput!
      ) {
        updateContract(input: $input) {
          contract {
            terms
          }
        }
      }
    `;

    const optimisticResponse = {
      updateContract: { contract: { id, terms } }
    };
    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id,
          terms
        }
      },
      optimisticResponse,
      onCompleted,
      onError
    });
  }

  resetTerms() {
    this.setState({ terms: this.props.node.terms });
  }

  createSignatureBlock(signatureBlock, successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
    };
    const onCompleted = () => {
      if (successCb) successCb();
    };

    const mutation = graphql`
      mutation Terms_createContractSignatureBlockMutation(
        $input: CreateContractSignatureBlockInput!
      ) {
        createContractSignatureBlock(input: $input) {
          new_contract_signature_block_edge {
            node {
              id
              address
              address_visibility
              company_name
              company_name_visibility
              email
              email_visibility
              name
              name_visibility
              phone
              phone_visibility
              signature_type
              signature_typed_name
              signed_at
              signer_fills_fields
              signing_party
              share_token
              title
              title_visibility
            }
          }
        }
      }
    `;

    const parentID = this.props.node.id;

    const configs = [
      {
        type: 'RANGE_ADD',
        parentID,
        edgeName: 'new_contract_signature_block_edge',
        connectionInfo: [
          {
            key: 'ContractContainer_contract_signature_blocks',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          contract_id: parentID,
          ...signatureBlock
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  render() {
    return (
      <div>
        <Terms
          canEdit={this.props.canEdit}
          localTerms={this.state.terms}
          reset={this.resetTerms}
          terms={this.props.node.terms}
          termsChangeHandler={this.termsChangeHandler}
          updateTerms={this.updateTerms}
          builderSaveTerms={this.builderSaveTerms}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/Terms.js